import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { JwtService } from '../services/jwt.service';

@Injectable()
export class UuidInterceptor implements HttpInterceptor {
  jwtTokenService: JwtService = inject(JwtService);
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const uuid = uuidv4();
      const token = this.jwtTokenService.getTokenJwt()
      if (token) {
        const cloned = httpRequest.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });

        return next.handle(cloned.clone());
      }
    return next.handle(httpRequest.clone());
  }
}
